import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ActivityIndicator = ({ className }) => (
  <div className={classnames('loading-gif', className)} />
);

ActivityIndicator.propTypes = {
  className: PropTypes.string,
};

export default ActivityIndicator;
